import ManageAgentById from "components/ManageAgent/ManageAgentById";
import ManageAgent from "components/ManageAgent";
import Main from "layouts/Main";
import React, { FC } from "react";
import { useParams } from "react-router-dom";

const ManageAgentbyIdPage: FC = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <Main namePage="ตัวแทน">
      <div className="layout-content">
        <ManageAgentById id={id ?? ""} />
      </div>
    </Main>
  );
};

export default ManageAgentbyIdPage;
